import styles from './styles.module.scss';
const ModalCloseIcon: React.FC = () => {
  return (
    <div className={styles['icon-container']}>
      <img src="/cross.png" className={styles['icon']} />
    </div>
  );
};

export default ModalCloseIcon;
